const badges = [
  { icon: "ri-shield-check-fill", label: "Licensed Contractor" },
  { icon: "ri-secure-payment-line", label: "Fully Insured" },
  { icon: "ri-award-fill", label: "15+ Years Experience" },
  { icon: "ri-verified-badge-line", label: "Quality Guaranteed" },
];

const reasons = [
  { icon: "ri-user-star-line", title: "Experienced Professionals", desc: "Our team brings years of hands-on construction expertise to every residential and commercial project in Colorado Springs and beyond." },
  { icon: "ri-focus-3-line", title: "Attention to Detail", desc: "We never cut corners. Every joint, finish, and fixture is executed with meticulous care, skilled craftsmanship, and pride in the work." },
  { icon: "ri-chat-check-line", title: "Transparent Communication", desc: "You are kept informed at every stage — no surprises, no hidden costs, just clear and honest updates from consultation to completion." },
  { icon: "ri-calendar-check-line", title: "On-Time Project Delivery", desc: "We respect your timeline. Our structured project management process ensures builds are completed on schedule and within agreed budgets." },
  { icon: "ri-building-4-line", title: "Long-Term Durability Focus", desc: "We select materials and construction methods built to last, protecting your investment for decades and withstanding Colorado's climate." },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-brand-warm-mid">
      <div className="max-w-7xl mx-auto px-6">
        {/* Trust badge strip */}
        <div className="flex flex-wrap gap-3 mb-14">
          {badges.map((b) => (
            <div
              key={b.label}
              className="inline-flex items-center gap-2 bg-white border border-brand-warm-deep rounded-full px-4 py-2"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${b.icon} text-brand-amber text-base`} />
              </span>
              <span className="text-xs font-body font-semibold text-brand-dark whitespace-nowrap">{b.label}</span>
            </div>
          ))}
        </div>

        {/* Header */}
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-body text-brand-amber uppercase tracking-widest font-semibold mb-3">
            Why Choose Us
          </p>
          <h2 className="font-heading font-bold text-4xl lg:text-5xl text-brand-dark leading-tight">
            Built on Quality,<br />Precision, and Trust
          </h2>
        </div>

        {/* Cards row */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {reasons.slice(0, 3).map((r) => (
            <div key={r.title} className="bg-white rounded-2xl p-7 border border-brand-warm-deep">
              <div className="w-11 h-11 flex items-center justify-center bg-brand-warm-mid rounded-xl mb-5">
                <i className={`${r.icon} text-xl text-brand-amber`} />
              </div>
              <h3 className="font-heading font-semibold text-lg text-brand-dark mb-2">{r.title}</h3>
              <p className="font-body text-sm text-brand-charcoal leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom 2 wide stat cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-brand-amber rounded-2xl p-8 text-white relative overflow-hidden">
            <div className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-white text-lg" />
              </span>
            </div>
            <p className="font-heading font-bold text-7xl mb-4 leading-none">98%</p>
            <h3 className="font-heading font-semibold text-xl mb-2">{reasons[3].title}</h3>
            <p className="font-body text-sm text-white/85 leading-relaxed">{reasons[3].desc}</p>
            <p className="font-body text-xs italic text-white/60 mt-4">&ldquo;Delivering on every promise, every time.&rdquo;</p>
          </div>
          <div className="bg-brand-sage rounded-2xl p-8 text-white relative overflow-hidden">
            <div className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-white text-lg" />
              </span>
            </div>
            <p className="font-heading font-bold text-7xl mb-4 leading-none">500+</p>
            <h3 className="font-heading font-semibold text-xl mb-2">{reasons[4].title}</h3>
            <p className="font-body text-sm text-white/85 leading-relaxed">{reasons[4].desc}</p>
            <p className="font-body text-xs italic text-white/60 mt-4">&ldquo;Structures that outlast expectations.&rdquo;</p>
          </div>
        </div>
      </div>
    </section>
  );
}
